/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-07-22 00:00:00
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { TextStyle, TextContainer, Modal, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { getShop } from 'src/helpers';

type Props = { loading: boolean };

type State = { availableModal: boolean };

type ComposedProps = Props & WithI18nProps;

class UpdatePermissionModal extends Component<ComposedProps, State> {
  state = { availableModal: false };

  componentDidMount() {
    const { pathName, updatedPermissionLink } = this.props;

    if (pathName === '/' && !_.isEmpty(updatedPermissionLink) && this.checkDateCondition()) {
      this.setState({ availableModal: true });
    }
  }

  proceedUpdatePermission = () => {
    const { updatedPermissionLink } = this.props;
    this.handleChange();
    window.top.location.href = updatedPermissionLink;
  };

  render() {
    const { availableModal } = this.state;
    const { i18n } = this.props;
    return (
      availableModal && (
        <Modal
          open={availableModal}
          onClose={this.handleChange}
          title={
            <p>
              {i18n.translate('AdminHTML.AppPermission.Modal.modalTitle', {
                t1: <strong>Important:</strong>
              })}
            </p>
          }
          primaryAction={{
            content: i18n.translate('AdminHTML.AppPermission.Actions.proceed'),
            onAction: this.proceedUpdatePermission
          }}
          secondaryActions={[
            {
              content: i18n.translate('AdminHTML.Common.Action.cancel'),
              onAction: this.handleChange
            }
          ]}>
          <Modal.Section>
            <TextContainer>
              <div>
                <TextStyle>
                  {i18n.translate('AdminHTML.AppPermission.Modal.modalContent_Text1', {
                    t1: (
                      <Link external url="https://shopify.dev/api/usage/access-scopes">
                        {i18n.translate('AdminHTML.AppPermission.Modal.modalContent_Text3')}
                      </Link>
                    )
                  })}
                </TextStyle>
              </div>
              <div>{i18n.translate('AdminHTML.AppPermission.Modal.modalContent_Text2')}</div>
            </TextContainer>
          </Modal.Section>
        </Modal>
      )
    );
  }

  handleChange = () => {
    this.setState({ availableModal: false });

    // Insert data to local storage
    try {
      const itemStorage = localStorage.getItem(`${getShop()}-proceedUpdatePermission`);
      const proceedUpdatePermission = itemStorage ? JSON.parse(itemStorage) : {};
      // get close times in localstorage
      const { times = 0 } = proceedUpdatePermission;
      localStorage.setItem(
        `${getShop()}-proceedUpdatePermission`,
        JSON.stringify({ day: Date.now(), times: times + 1 })
      );
    } catch (error) {}
  };

  checkDateCondition = () => {
    try {
      const itemStorage = localStorage.getItem(`${getShop()}-proceedUpdatePermission`);
      const proceedUpdatePermission = itemStorage ? JSON.parse(itemStorage) : {};
      const { day = 0, times = 0 } = proceedUpdatePermission;
      const now = Date.now();
      // check date condition
      if (times < 3) {
        return true;
      }
      // after third click, show pop-up every 7 days
      return moment(now).diff(day, 'days') >= 7;
    } catch (error) {}
    return true;
  };
}

const mapStateToProps = (state, props) => {
  const { oauth = {} } = state;
  const updatedPermissionLink = _.get(oauth, 'tenantApp.appParams.updatedPermissionLink', '');

  return { updatedPermissionLink };
};

const UpdatePermissionForm = reduxForm({
  form: 'UpdatePermissionForm', // a unique identifier for this form
  enableReinitialize: true
})(UpdatePermissionModal);

export default withI18n()(connect(mapStateToProps)(UpdatePermissionForm));
